<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Edit layout title - Edit') }}: {{ documentType?.document_type ?? '' }}</h4>
        <button type="button" class="close" (click)="_activeModal.close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body py-2 px-0" tabindex="0" ngbAutofocus>
        <div class="CC_editLayoutScrollCont">
            <app-edit-layout-content 
                [layoutsetting]="ccLayoutSettings"
                (drop)="drop($event)"
                (removeFieldFromCustomBox)="removeFieldFromCustomBox($event)"
                (addFieldsInCustomBox)="addFieldsInCustomBox($event)"
                (removeCustomBox)="removeCustomBox($event)"
                (updateFieldsOrders)="updateFieldsOrders($event)"
                [loading]="updateLayoutSettingsRequestState$ | async"
                (updateVisibility)="updateVisibility($event)"
                (createCustomBox)="createCustomBox()"
                [metaDataItems]="metaDataItems$ | async"
                (updateLayoutSettings)="updateLayoutSettings()"
            ></app-edit-layout-content>
        </div>
    </div>
</ng-container>